import React from 'react';
import { StarIcon } from 'lucide-react';
import { useRegistration } from './RegistrationContext';
import { useWebinarSlot } from './useWebinarSlot';
export const FinalCTA = () => {
  const {
    openPopup
  } = useRegistration();
  const slot = useWebinarSlot();
  return <section className="mb-12" data-id="element-240" data-mp="c4fuggqtgrop">
      <div className="bg-red-50 border-2 border-red-400 rounded-lg p-4 mb-6 text-center" data-id="element-241" data-mp="84ntap3r5ntd">
        <p className="text-red-700 font-bold text-lg" data-id="element-242" data-mp="m4orfwsmuh55">⚠️ BEPERKTE PLEKKEN ⚠️</p>
      </div>

      <div className="bg-white border-2 border-green-500 rounded-lg p-8 text-center" data-id="element-243" data-mp="h655vxhyb7db">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-244" data-mp="vurwwwgxxnkd">
          Leer vandaag nog "Communiceren met je Hond"
        </h2>

        <p className="text-lg text-gray-700 mb-2" data-id="element-245" data-mp="qwq3pipsw7v6">
          {slot.dayPrefix} {slot.dateLabel} • {slot.time}
        </p>

        <div className="inline-block bg-green-500 text-white px-6 py-2 rounded-full font-bold text-2xl mb-6" data-id="element-246" data-mp="14vzfm66z4ftc">
          GRATIS
        </div>

        <p className="text-sm text-gray-600 mb-6" data-id="element-247" data-mp="2c4wmyl7pu6ft">Geen verborgen kosten</p>

        <button onClick={openPopup} className="w-full bg-green-500 hover:bg-green-600 text-white font-bold py-5 px-8 rounded-lg transition-colors text-xl mb-6 animate-pulse" data-id="element-248" data-mp="2c6rc6bq0skpp">
          JA, IK WIL MIJN HOND EINDELIJK BEGRIJPEN - GRATIS AANMELDEN
        </button>

        <p className="text-gray-700 leading-relaxed mb-4" data-id="element-249" data-mp="2qzughhelp1yh">
          In 90 minuten van frustratie naar begrip, van gissen naar weten, van
          reageren naar communiceren
        </p>

        <div className="flex items-center justify-center" data-id="element-250" data-mp="3010wzqh92crq">
          <div className="flex mr-2" data-id="element-251" data-mp="34t28ha6lfzgp">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-252" data-mp="39s5dwvqhk7p7" data-mpi={i} />)}
          </div>
          <span className="text-sm font-semibold text-gray-700" data-id="element-253" data-mp="3etcm2vwjj8we">
            Meer dan 100.000 deelnemers in 2025
          </span>
        </div>
      </div>

      <p className="text-center text-lg font-semibold text-gray-800 mt-8" data-id="element-254" data-mp="1jnk104omporl">
        Want soms kan anderhalf uur alles veranderen.
      </p>
    </section>;
};